/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { CircuitList } from 'libs/sysque/toolbelt/feature/src/lib/models/paneldata-info';
import { Observable } from 'rxjs';
import { SelectedPanelDataItem } from 'libs/sysque/toolbelt/feature/src/lib/models/selected-panel-data-item';

export interface IPanelDataFacade {
  initializeProjectData(): Promise<string[]>;
  getPanelData(projectName: string, initialize: boolean): Promise<string[]>;
  getCircuitData(projectName: string, panelName: string): Promise<CircuitList[]>
  validateSelection(): Observable<any>;
  windowResize(height: number): void;
  closeWindow(): Observable<boolean>;
  localStorageUpdate(key: string, value: any): unknown;
  localStorageGetItem(key: string): string;
  applyPanelData(item: SelectedPanelDataItem): void;  
}

export const PANEL_DATA_FACADE_TOKEN = new InjectionToken<IPanelDataFacade>('PANEL_DATA_FACADE_TOKEN');
